// extracted by mini-css-extract-plugin
module.exports = {"mental":"mental_mental__zMnaj","warning":"mental_warning__o9QXZ","titleBox":"mental_titleBox__oCd4v","title":"mental_title__mRXLP"};